module.exports = __webpack_public_path__ + "static/img/rank_208.d94e874.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_208.png
// module id = JLUw
// module chunks = 1